<template>
  <div class="">
    <h2 class="text-md border-b border-b2c-grey-600 pb-3">{{$t('userData.myData')}}</h2>
    <section v-if="customer">
      <section v-if="!edit" class="text-md">
        <div class="flex justify-end mt-4">
          <button class="pr-2 w-6 flex hover:text-b2c-red-300" @click="activeEdit()" title="edit">
              <svg
                width="100%"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="pen"
                class="svg-inline--fa fa-pen fa-w-16"
                role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"></path>
              </svg>
            </button>
        </div>

        <div class="flex mt-3 ml-1 container">
          <label class="radio flex items-center" v-if="customerType==='F'">
            <input type="radio" v-model="customerType" value="F" class="focus:bg-white">
            <span for="" class="pl-6 text-xs" :class="fontThin()">
              {{$t('userData.private')}}
            </span>
          </label>
          <label class="radio flex items-center" v-if="false">
            <input type="radio" v-model="customerType" value="P" class="focus:bg-white">
            <span class="pl-6 text-xs" :class="fontThin()">
              {{$t('userData.company')}}
            </span>
          </label>
        </div>

        <div v-if="customerType==='F'">
          <div class="flex justify-between" >
            <material-label class="mt-6 mr-6 w-full" :name="$t('addressForm.firstname')" :value="customer.firstname" />
            <material-label class="mt-6 w-full" :name="$t('addressForm.lastname')" :value="customer.lastname" />
          </div>

          <div class="flex justify-between items-center mt-4" v-if="showTaxNumber">
            <material-label class="w-full" :name="$t('addressForm.taxNumber')" :value="customer.tax_number" />
          </div>

          <div class="flex justify-between items-end mt-4">
            <div class="flex flex-col w-1/2 mr-6" v-if="customer.birthday">
              <label for="datepicker" class="text-sm text-blackish pl-2 pt-2" :class="fontHairline()">
                {{ $t('userData.birthday') }}
              </label>
              <datepicker
                id="datepicker"
                :placeholder="$t('userData.dateFormatPlaceholder')"
                v-model="customer.birthday"
                :format="$t('userData.dateFormat')"
                input-class="outline-none bg-white"
                :disabled="true"
                class="pl-2 pt-1 pb-2 border-b border-gray-300 outline-none" />
            </div>
            <material-label v-else class="mt-6 w-1/2 mr-6" :name="$t('userData.birthday')" :value="customer.birthday" />
            <material-label class="mt-6 w-1/2" :name="$t('userData.job')" :value="customer.job" />
          </div>
        </div>
        <div v-else>
          <div class="flex justify-between mt-6">
            <material-label class="mt-6 mr-6 w-full" :name="$t('userData.company')" :value="customer.company" />
          </div>
          <div class="flex justify-between">
            <material-label class="mt-6 mr-6 w-full" :name="$t('userData.vat')" :value="customer.vat_id" />
          </div>
        </div>

        <address-labels class="mt-6" :address="billingAddress ? billingAddress : editedBillingAddress" />
      </section>
      <section v-else>
        <div class="flex justify-center mb-10" v-if="!billingAddress">
          <span class="mt-4 py-2 w-full text-center bg-b2c-red-100 text-gray-700"
            @click="edit=true">
              {{$t('userData.complete')}}</span>
        </div>
        <div class="flex mt-5 container">
          <label class="radio flex items-center">
            <input type="radio" v-model="customerType" value="F" class="focus:bg-white">
            <span for="" class="pl-6 text-xs" :class="fontThin()">
              {{$t('userData.private')}}
            </span>
          </label>
          <label class="radio flex items-center ml-10" v-if="false">
            <input type="radio" v-model="customerType" value="P" class="focus:bg-white">
            <span for="" class="pl-6 text-xs" :class="fontThin()">
              {{$t('userData.company')}}
            </span>
          </label>
        </div>
        <div v-if="false" class="mt-6">
          <div @mouseover="showMessage=true" @mouseout="showMessage=false" class="flex items-center w-1/2">
            <label class="radio flex items-center" v-if="customerType==='F'">
              <input type="radio" v-model="customerType" value="F" class="focus:bg-white">
              <span for="" class="pl-6 text-xs" :class="fontThin()">
                {{$t('userData.private')}}
              </span>
            </label>
            <label class="radio flex items-center" v-else>
              <input type="radio" v-model="customerType" disabled value="F" class="focus:bg-white">
              <span for="" class="pl-6 text-xs" :class="fontThin()">
                {{$t('userData.private')}}
              </span>
            </label>
            <label class="radio flex items-center ml-10" v-if="customerType==='P'">
              <input type="radio" v-model="customerType" value="P" class="focus:bg-white">
              <span for="" class="pl-6 text-xs" :class="fontThin()">
                {{$t('userData.company')}}
              </span>
            </label>
            <label class="radio flex items-center ml-10" v-else>
              <input type="radio" v-model="customerType" disabled value="P" class="focus:bg-white">
              <span for="" class="pl-6 text-xs" :class="fontThin()">
                {{$t('userData.company')}}
              </span>
            </label>
          </div>
          <div v-if="showMessage" class="text-white bg-b2c-grey-400 p-2 mt-2">
            {{$t('userData.cannotChange')}} <br>
            {{$t('userData.createNew')}}
          </div>
        </div>

        <div v-if="customerType==='F'">
          <div class="flex justify-between items-center mt-12">
            <material-input class="w-full" :name="$t('addressForm.firstname')" :showMessage="showMessages"  v-model="editedCustomer.firstname" />
            <span class="text-2xl pt-4">*</span>
            <material-input class="ml-6 w-full" :name="$t('addressForm.lastname')" :showMessage="showMessages"  v-model="editedCustomer.lastname" />
            <span class="text-2xl pt-4">*</span>
          </div>

          <div class="flex justify-between items-center mt-8" v-if="showTaxNumber">
            <material-input class="w-full" :name="$t('addressForm.taxNumber')" :brackets="$t('addressForm.taxNumberBracket')" required v-model="editedCustomer.tax_number"
            :showMessage="showMessages || showTaxNumberMessage" @change="checkTaxNumber"
            :message="showTaxNumberMessage ? taxNumberMessage : $t('input.fillField')"
            :textColor="showTaxNumberMessage ? 'text-yellow-600' : null" />
            <span class="text-md">*</span>
          </div>

          <div class="flex justify-between items-end mt-4">
            <div class="flex flex-col w-1/2 mr-6">
              <label for="datepicker" class="text-sm text-blackish pl-2 pt-2">
                {{ $t('userData.birthday') }}
              </label>
              <datepicker
                id="datepicker"
                ref="datepicker"
                :placeholder="$t('userData.dateFormatPlaceholder')"
                :language="languages[$i18n.locale]"
                v-model="birthday"
                :format="$t('userData.dateFormat')"
                input-class="outline-none"
                class="pl-2 pt-3 border-b border-gray-300 outline-none" />
            </div>

            <material-input class="mt-6 w-1/2" :name="$t('userData.job')" v-model="job" />
          </div>
        </div>
        <div v-else>
          <div class="flex justify-between items-center mt-12">
            <material-input class="w-full" :name="$t('userData.company')" :showMessage="showMessages"  v-model="editedCustomer.company" />
            <span class="text-2xl pt-4 mr-6">*</span>
          </div>
          <div class="flex justify-between">
            <material-input class="w-full" :name="$t('userData.vat')" :showMessage="showMessages"  v-model="editedCustomer.vat_id" />
            <span class="text-2xl pt-4 mr-6">*</span>
          </div>
        </div>

        <div class="flex justify-between items-center mt-12">
          <material-input class="w-2/3" :name="$t('addressForm.street')" :showMessage="showMessages"  v-model="editedBillingAddress.street_name" />
          <span class="text-2xl pt-4">*</span>
          <material-input class="ml-6 w-1/4" :name="$t('addressForm.number')" v-model="editedBillingAddress.street_number" />
        </div>

        <div class="flex justify-between items-center mt-6">
          <material-input class="w-full" :name="$t('addressForm.postcode')" :showMessage="showMessages" v-model="editedBillingAddress.postcode" />
          <span class="text-2xl pt-4">*</span>
          <material-input class="ml-6 w-full" :name="$t('addressForm.city')" :showMessage="showMessages" v-model="editedBillingAddress.city" />
          <span class="text-2xl pt-4">*</span>
        </div>

        <div class="flex justify-between items-center">
          <div class="w-1/2 mt-6 flex items-center mr-6">
            <material-input class="w-full" :name="$t('addressForm.state')" :showMessage="showMessages" v-model="editedBillingAddress.state" />
            <span class="text-2xl pt-4">*</span>
          </div>
          <select-country v-model="editedBillingAddress.country" />
          <span class="text-2xl pt-4">*</span>
        </div>

        <div class="flex w-full items-center mt-6">
          <material-input class="w-full" :name="$t('addressForm.phone')" :showMessage="showMessages" v-model="editedBillingAddress.phone" />
          <span class="text-2xl pt-4">*</span>
        </div>

        <material-input class="mt-6" :name="$t('addressForm.note')" v-model="editedBillingAddress.note" />

        <div class="flex justify-between mt-10">
          <div class="flex justify-center mb-10">
            <button class="mt-4 p-3 shadow-md rounded-md w-32
              hover:bg-b2c-red-300 hover:text-white bg-white"
              @click="edit=false" v-if="billingAddress">
                {{$t('userData.cancel')}}</button>
          </div>
          <div class="flex justify-center mb-10" v-if="!this.billingAddress">
            <button class="mt-4 p-3 shadow-md rounded-md w-32
              hover:bg-b2c-red-300 hover:text-white bg-white"
              @click="save">
                {{$t('userData.save')}}</button>
          </div>
          <div class="flex justify-center mb-10" v-else>
            <button class="mt-4 p-3 shadow-md rounded-md w-32
              hover:bg-b2c-red-300 hover:text-white bg-white"
              @click="update">
                {{$t('userData.save')}}</button>
          </div>
        </div>
      </section>

      <div v-if="!editLocale" class="flex items-center justify-between mt-16">
        <material-label  class="mr-6 w-1/2" :name="$t('userData.language')" :value="userLocale" />
        <button class="hidden md:block p-2 px-6 rounded-md shadow-md hover:bg-b2c-red-300 hover:text-white "
          @click="editLocale=true">
            {{$t('userData.changeLanguage')}}
        </button>
        <button class="md:hidden p-2 px-6 shadow-md rounded-md text-b2c-red-300 "
          @click="editLocale=true">
            {{$t('userData.changeLanguage')}}
        </button>
      </div>

      <div v-else class="flex flex-col mt-16">
        <label class="text-xs text-blackish pl-2 mb-2" :class="fontHairline()">
            {{$t('userData.language')}}
        </label>
        <div class="flex relative">
          <select name="locale" v-model="userLocale" @change="updateLanguage"
            class="w-1/2 shadow-md rounded-md p-2 outline-none appearance-none ml-1">
              <option :value="locale.name" v-for="locale in locales" :key="locale.code">
                {{ locale.name }}
              </option>
          </select>
          <div class="flex items-center">
            <div class="w-1/2 pointer-events-none right-1 absolute mr-2">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657
                8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <h2 class="text-md border-b border-b2c-grey-600 pb-3 mt-24 uppercase">{{$t('userData.myHarps')}}</h2>
      <div class="flex flex-col items-center">
        <div v-for="harp in customerHarps" :key="harp.id" class="flex w-full items-center">
          <material-label  class="mt-6 mr-6 w-full" :value="harp.description" />
          <button class="hover:text-b2c-red-300 w-3 pt-4" @click="deleteYourHarp(harp)" title="delete">
            <bin-icon />
          </button>
        </div>

        <div class="w-full mt-6 flex" v-if="!addHarp">
          <button class="hidden md:block p-2 px-6 rounded-md shadow-md hover:bg-b2c-red-300 hover:text-white "
          @click="addHarp=true">
            {{$t('userData.addHarp')}}
          </button>
          <button class="md:hidden p-2 px-6 shadow-md rounded-md text-b2c-red-300 "
          @click="addHarp=true">
            {{$t('userData.addHarp')}}
          </button>
        </div>

        <add-harp v-else :harps="harps" @added-harp="loadCustomerHarps()" @not-added="addHarp=false" class="mt-10" />
      </div>
    </section>
    <div v-else>
      <div class="flex justify-between" >
        <material-label class="mt-6 mr-6 w-full" :name="$t('addressForm.firstname')" :value="user.firstname" />
        <material-label class="mt-6 w-full" :name="$t('addressForm.lastname')" :value="user.lastname" />
      </div>
    </div>

    <h2 class="text-md border-b border-b2c-grey-600 pb-3 mt-32 uppercase"> {{ $t('stripe.mine') }} </h2>
    <payments-list />

    <h2 class="text-md border-b border-b2c-grey-600 pb-3 mt-32">{{$t('userData.accessData')}}</h2>
    <div class="flex justify-between items-center mb-20">
      <material-label class="mt-6 mr-6" name="Email" :value="user.email" />
       <button
        class="text-b2c-grey-400 hover:text-b2c-red-300 transform rounded p-1 mt-10
          flex items-center justify-end text-sm"
        @click="changePassword=!changePassword">
          <span class="px-2"> {{$t('password.changePassword')}}</span>
          <svg
            width="3%"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas" data-icon="angle-down"
            class="svg-inline--fa fa-angle-down fa-w-10"
            role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
              <path fill="currentColor" d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"></path>
          </svg>
        </button>
    </div>

    <div v-if="changePassword" class="w-3/4 md:w-1/2 mb-20">
      <material-input class="mt-10" type="password" :name="$t('password.old')" v-model="updatePassword.oldPassword" />
      <material-input class="mt-4" type="password" :name="$t('password.new')" v-model="updatePassword.newPassword" />
      <material-input class="mt-4" type="password" :name="$t('password.newConfirm')" v-model="updatePassword.confirmNewPassword" />
      <button
        class="hidden md:block shadow-md text-b2c-grey-400 hover:bg-b2c-red-300 hover:text-white
        rounded-md p-2 px-3 mt-10"
        @click="saveNewPassword"
        :class="isLoading ? 'loader' : ''">
          {{$t('password.savePassword')}}
      </button>
      <button
        class="md:hidden bg-b2c-red-300 text-white rounded p-2 px-3 mt-10"
        @click="saveNewPassword"
        :class="isLoading ? 'loader' : ''">
          {{$t('password.savePassword')}}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import store from '@/store/index';
import MaterialInput from '@/components/blocks/MaterialInput.vue';
import MaterialLabel from '@/components/blocks/MaterialLabel.vue';
import AddressLabels from '@/components/profile/AddressLabels.vue';
import AddHarp from '@/components/graphics/AddHarp.vue';
import { getSupportedLocales } from '@/util/i18n/supported-locales';
import { getCustomerOrders } from '@/services/OrdersService';
import { getCustomerHarps, deleteHarp, getHarps } from '@/services/HarpsService';
import BinIcon from '@/components/graphics/BinIcon.vue';
import Datepicker from 'vuejs-datepicker';
import { en, it, de } from 'vuejs-datepicker/dist/locale';
import TranslationsMixin from '@/mixins/TranslationsMixin';
import {
  checkInput, isValidTaxNumber, saveNewAddress, updateGivenAddress, TaxNumberValidation,
} from '@/services/AddressesService';
import SelectCountry from '../graphics/SelectCountry.vue';
import PaymentsList from './PaymentsList.vue';

export default {
  data() {
    return {
      languages: {
        en,
        it,
        de,
      },

      birthday: null,
      job: '',

      edit: false,
      editLocale: false,
      editedCustomer: {
        firstname: '',
        lastname: '',
        company: '',
        vat_id: '',
        tax_number: '',
        type: '',
      },

      locales: [],
      userLocale: '',

      customerType: '',

      editedBillingAddress: {
        type: 'B',
        company: '',
        firstname: '',
        lastname: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
        phone: '',
        note: '',
      },

      showMessages: false,

      addHarp: false,
      harps: [],
      customerHarps: [],
      newHarp: '',

      changePassword: false,

      updatePassword: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      },

      isLoading: false,

      hasOrders: false,
      showMessage: false,

      showTaxNumberMessage: false,
      taxNumberMessage: this.$t('addressForm.taxNumberMessage'),
    };
  },

  components: {
    MaterialInput,
    MaterialLabel,
    AddressLabels,
    AddHarp,
    SelectCountry,
    BinIcon,
    Datepicker,
    PaymentsList,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      customer: 'auth/customer',
      billingAddress: 'auth/billingAddress',
      currency: 'auth/currency',
      vat: 'auth/vat',
      changedLocale: 'auth/changedLocale',
      isItaly: 'isItaly',
    }),

    showTaxNumber() {
      if (this.isItaly && (!this.editedBillingAddress.country || this.editedBillingAddress.country === 'IT')) {
        return true;
      }
      return false;
    },
  },

  watch: {
    changedLocale() {
      this.userLocale = this.locales.find((locale) => locale.code === this.user.lang).name;
    },

    edit() {
      this.showMessages = false;
      this.showTaxNumberMessage = false;
    },
  },

  created() {
    if (this.customer) {
      getCustomerOrders(this.customer)
        .then(({ data }) => {
          if (data.length > 0) this.hasOrders = true;
        }).catch((error) => {
          this.checkRoutingAuthentication(error);
        });
    }
    getHarps().then(({ data }) => {
      this.harps = data;
    }).catch(() => {
      this.createNotification('error', `${this.$t('notifications.errorReload')}`);
    });

    getSupportedLocales().then(({ data }) => {
      this.locales = data;
      this.userLocale = this.locales.find((locale) => locale.code === this.user.lang).name;
    });
  },

  mounted() {
    if (this.customer) {
      this.loadCustomerHarps();
      this.customerType = this.customer.type;
      this.editedCustomer.firstname = this.customer.firstname;
      this.editedCustomer.lastname = this.customer.lastname;
      this.editedCustomer.tax_number = this.customer.tax_number;
      if (this.customer.birthday) this.editedCustomer.birthday = this.customer.birthday;
      if (this.customer.job) this.editedCustomer.job = this.customer.job;
      this.editedCustomer.company = this.customer.company;
      if (this.customer.vat_id) this.editedCustomer.vat_id = this.customer.vat_id;
      if (!this.billingAddress) {
        this.edit = true;
      } else {
        this.editedBillingAddress = this.billingAddress;
      }
    }
  },

  mixins: [TranslationsMixin],

  methods: {
    loadCustomerHarps() {
      this.addHarp = false;
      getCustomerHarps(this.customer.id).then((response) => {
        this.customerHarps = response.data;
      }).catch((error) => {
        this.checkRoutingAuthentication(error);
      });
    },

    saveNewPassword() {
      this.isLoading = true;
      axios.put(`/api/users/${this.user.id}/password`, this.updatePassword).then(() => {
        this.changePassword = false;
        this.updatePassword.oldPassword = '';
        this.updatePassword.newPassword = '';
        this.updatePassword.confirmNewPassword = '';
        this.isLoading = false;
        this.createNotification('success', `${this.$t('notifications.updatePassword')}`);
      }).catch((error) => {
        this.isLoading = false;
        this.checkSessionErrorNotification(error);
      });
    },

    activeEdit() {
      this.edit = true;
      this.birthday = this.customer.birthday;
      this.job = this.customer.job;
      this.editedCustomer.tax_number = this.customer.tax_number;
    },

    checkTaxNumber() {
      this.showTaxNumberMessage = false;
      TaxNumberValidation(this.editedCustomer.tax_number).then(() => {
      }).catch((errors) => {
        const message = errors.response.data.errors.codice_fiscale[0];
        this.taxNumberMessage = message;
        this.showTaxNumberMessage = true;
      });
    },

    async save() {
      if (this.showTaxNumber) {
        if (this.editedCustomer.tax_number && isValidTaxNumber(this.editedCustomer.tax_number)) {
          await this.updateCustomer();
          this.saveAddress();
          return;
        }
        this.showTaxNumberMessage = true;
      }
      if (!this.showTaxNumber) {
        await this.updateCustomer();
        this.saveAddress();
        return;
      }
      this.showMessages = true;
    },

    async updateCustomer() {
      this.editedCustomer.type = this.customerType;
      if (this.birthday) this.editedCustomer.birthday = this.birthday;
      if (this.job) this.editedCustomer.job = this.job;
      await axios.put(`/api/customers/${this.customer.id}`, this.editedCustomer);
    },

    saveAddress() {
      this.editedBillingAddress.firstname = this.editedCustomer.firstname;
      this.editedBillingAddress.lastname = this.editedCustomer.lastname;
      if (!this.editedBillingAddress.company) {
        this.editedBillingAddress.company = `${this.customer.firstname} ${this.customer.lastname}`;
      }
      if (checkInput(this.editedBillingAddress)) {
        saveNewAddress(this.customer.id, this.editedBillingAddress).then(({ data }) => {
          store.dispatch('auth/auth');
          this.editedBillingAddress = data;
          this.edit = false;
        }).catch(() => {
          this.showMessages = true;
        });
        return;
      }
      this.showMessages = true;
    },

    async update() {
      if (this.showTaxNumber && this.editedCustomer.tax_number) {
        if (this.editedCustomer.tax_number && isValidTaxNumber(this.editedCustomer.tax_number)) {
          await this.updateCustomer();
          this.updateAddress();
          return;
        }
        this.showTaxNumberMessage = true;
      }
      if (!this.showTaxNumber) {
        await this.updateCustomer();
        this.updateAddress();
        return;
      }
      this.showMessages = true;
    },

    updateAddress() {
      this.editedBillingAddress.firstname = this.editedCustomer.firstname;
      this.editedBillingAddress.lastname = this.editedCustomer.lastname;
      this.editedBillingAddress.company = `${this.editedBillingAddress.firstname} ${this.editedBillingAddress.lastname}`;
      if (checkInput(this.editedBillingAddress)) {
        updateGivenAddress(this.editedBillingAddress).then(({ data }) => {
          store.dispatch('auth/auth');
          this.editedBillingAddress = data;
          this.edit = false;
        }).catch(() => {
          this.showMessages = true;
        });
        return;
      }
      this.showMessages = true;
    },

    updateLanguage() {
      this.editLocale = false;
      this.updateUserLanguage(this.userLocale);
    },

    deleteYourHarp(harp) {
      deleteHarp(harp.id, this.customer.id).then(() => {
        getCustomerHarps(this.customer.id).then((response) => {
          this.customerHarps = response.data;
        }).catch(() => {
          this.createNotification('error', `${this.$t('notifications.errorReload')}`);
        });
      }).catch((error) => {
        this.checkSessionErrorNotification(error);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container input {
  display: none;
}

.container span {
  display: block;
  border-radius: 50%;
  position: relative;
  transition: all 0.25s linear;
}
.container span:before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  -webkit-transform: translatey(-50%);
          transform: translatey(-50%);
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 2px solid #ddd;
  transition: all 0.25s linear;
}

.container .radio input:checked + span:before {
  background-color: black;
}

// Da aggiornare con tailwind
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
